/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

const chance = new Chance();

export default () => ({
  id: `http://graph.seek.com/Location/${chance.integer({
    min: 0,
    max: 9999,
  })}`,
  isoCode: chance.pickone(['AU', 'NZ']),
  name: chance.pickone(['Australia', 'New Zealand']),
});
